import React, { useContext, useEffect } from "react";
import { ThemeContext } from "./ThemeContext";
import "./App.css";
import DarkModeToggle from "react-dark-mode-toggle";

const Header = () => {
  const [dar, setDar] = useContext(ThemeContext);
  useEffect(() => {
    console.log(dar);
  }, []);

  return (
    <div className={dar ? "dark-mode" : "light-mode"}>
      <div>
        <h1
          style={{
            fontWeight: "bold",
            paddingTop: 10,
            color: dar ? "white" : "black",
            fontSize: 24,
            verticalAlign: "middle"
          }}>
          Meme Maker
        </h1>
      </div>
      <div style={{ paddingTop: 15 }}>
        <DarkModeToggle
          onChange={() => setDar(prev => !prev)}
          checked={dar}
          size="50px"
        />
      </div>
    </div>
  );
};
export default Header;
